<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M12.5 10V15"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 12.5H15"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.6667 6.66675H8.33334C7.41286 6.66675 6.66667 7.41294 6.66667 8.33341V16.6667C6.66667 17.5872 7.41286 18.3334 8.33334 18.3334H16.6667C17.5871 18.3334 18.3333 17.5872 18.3333 16.6667V8.33341C18.3333 7.41294 17.5871 6.66675 16.6667 6.66675Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.33334 13.3334C2.41667 13.3334 1.66667 12.5834 1.66667 11.6667V3.33341C1.66667 2.41675 2.41667 1.66675 3.33334 1.66675H11.6667C12.5833 1.66675 13.3333 2.41675 13.3333 3.33341"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconDuplicate',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
